export enum EventStatus {
	Upcoming = 'upcoming',
	Active = 'active',
	Closed = 'closed',
}
